export class MapStyleClient {
  constructor({ url, _get }) {
    this.url = url
    this.get = _get
  }

  help() {
    console.log('getByName(name)')
    console.log('getPinImage(name)')
  }

  async getByName(name) {
    if (!name) return []
    if (name.toUpperCase() === 'DEFAULT') return []

    const url = `${this.url}/api/app/mapStyle/get/${name}`
    const res = await this.get(url, { result: [] })
    return res.result
  }

  getPinImage(styleName) {
    let image = 'maps_pin_red.png'

    if(styleName === 'blue-ice') {
      image = 'maps_pin_grey.png'
    }

    return `${this.url}/${image}`
  }
}
